import { Component, h } from 'preact'
import Table from '../table/Table'
import axios from 'axios'
import AnalyticsDateFormatter from './AnalyticsDateFormatter'
import { Sort } from '../table/types'
import { Loader } from './Loader'

interface Props {
  startDate: Date,
  endDate: Date,
  selectedRoles: Array<string>,
  selectedContentTypes: Array<string>
  selectedCategories: Array<string>
}

interface SortingObject {
  [key: string]: any
}

interface PopularCategoryRepresentation {
  category_name: string,
  posts: number,
  topics: number,
  replies: number,
  likes: number
}

interface State {
  popularCategories: Array<PopularCategoryRepresentation>,
  sorting: Sort,
  isLoading: boolean
}

class PopularCategoriesTable extends Component<Props, State> {
  constructor () {
    super()
    this.setState({
      popularCategories: [],
      sorting: {
        order: 'posts',
        direction: 'desc'
      },
      isLoading: true
    })
  }

  async componentDidUpdate (prevProps: Props, prevState: State) {
    if (this.props.startDate !== prevProps.startDate || this.props.endDate !== prevProps.endDate || this.props.selectedRoles !== prevProps.selectedRoles || this.props.selectedContentTypes !== prevProps.selectedContentTypes || this.props.selectedCategories !== prevProps.selectedCategories) {
      await this.fetchPopularTopics()
    }
  }

  async fetchPopularTopics () {
    this.setState({ isLoading: true })
    try {
      const res = await this.fetchData('/analyticsV2/fetchPopularCategories')
      this.setState({
        popularCategories: res.data,
        isLoading: false
      })
    } catch {
      this.setState({ isLoading: false })
    }
  }

  async fetchData (url: string) {
    const { startDate, endDate, selectedRoles, selectedContentTypes, selectedCategories } = this.props
    const filterOptions = {
      start: AnalyticsDateFormatter.formatDate(startDate),
      end: AnalyticsDateFormatter.formatDate(endDate, false),
      roles: selectedRoles,
      contentTypes: selectedContentTypes,
      categories: selectedCategories
    }
    return axios.post(url, {
      filters: filterOptions
    })
  }

  getModel () {
    return [
      { header: 'Published in', accessor: 'category_name', size: 'm' },
      { header: 'Posts', accessor: 'posts', size: 'xs-right', sorting: 'posts' },
      { header: 'Topics', accessor: 'topics', size: 'xs-right', sorting: 'topics' },
      { header: 'Replies', accessor: 'replies', size: 'xs-right', sorting: 'replies' },
      { header: 'Likes', accessor: 'likes', size: 'xs-right', sorting: 'likes' }
    ]
  }

  render (_: Props, { popularCategories, sorting, isLoading }: State) {
    return <div className='dashboard-table-wrapper'>
      {isLoading ? <Loader parentCustomClass='dashboard-table-loader' />
        : <Table
          model={this.getModel()}
          rows={popularCategories}
          classes={['popular_categories__table']}
          onSortChange={(attr) => {
            let newSorting: Sort
            if (sorting && sorting.order === attr) {
              newSorting = {
                order: attr,
                direction: sorting.direction === 'asc' ? 'desc' : 'asc'
              }
            } else {
              newSorting = {
                order: attr,
                direction: 'asc'
              }
            }
            popularCategories.sort((a: SortingObject, b: SortingObject) => {
              if (a[attr] > b[attr]) return 1 * (newSorting.direction === 'asc' ? 1 : -1)
              if (a[attr] < b[attr]) return -1 * (newSorting.direction === 'asc' ? 1 : -1)
              return 0
            })
            this.setState({
              sorting: newSorting
            })
          }}
          sort={sorting}
        />}
    </div>
  }
}

export default PopularCategoriesTable
